import { useSelector } from "react-redux";
import { selectAnswerById } from "reducers/answersSlice";
import Select from "components/input-types/Select";
import { selectAssetCategory } from "./assetCategorySlice";

const MinorCategory = (props) => {
	const { row } = props;
	const majorCategory = useSelector((state) =>
		selectAnswerById(state, row?.q3a || "")
	)?.value;
	const assetCategory = useSelector(selectAssetCategory).filter(
		(c) => c.major === majorCategory
	);
	const lookup = [
		...new Set(
			assetCategory.map((c) => ({
				id: c.minor,
				domainCode: "MinorAssetCategory",
				code: c.minor,
				description: c.minor,
			}))
		),
	];

	return <Select {...props} lookup={lookup} />;
};

export default MinorCategory;
